<template>
    <div>
        <div class="col-md-12 mx-auto">
            <v-dialog
                    v-model="defaultTitle"
                    persistent
                    max-width="500"
                    class="px-5"
            >
                <v-card>
                    <v-toolbar
                            flat
                            dark
                            color="primary"
                    >

                        <v-toolbar-title> متن آماده</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn
                                    icon
                                    dark
                                    @click="defaultTitle = false"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card-text class="pt-5">
                        <v-autocomplete label="متن پیشفرض" @input="setTitle" chips deletable-chips :items="texts"
                                        item-text="title"
                                        prepend-inner-icon="fa fa-pencil-alt"
                                        :id="texts.id">
                            <template v-slot:item="data">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span class="text-capitalize"> {{ index }} -  {{
                                                data.item.title
                                            }} - {{ data.item.category }}</span>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-autocomplete>
                        <v-autocomplete label="آگهی پیشفرض" @input="setTitle" chips deletable-chips :items="Ads"
                                        item-text="title"
                                        prepend-inner-icon="fa fa-pencil-alt"
                                        :id="Ads.id">
                            <template v-slot:item="data">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span class="text-capitalize"> {{ index }} -  {{ data.item.title }}</span>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-autocomplete>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog
                    v-model="getText"
                    persistent
                    max-width="500"
                    class="px-5"
            >
                <v-card>
                    <v-toolbar
                            flat
                            dark
                            color="primary"
                    >

                        <v-toolbar-title>
                            <div class="row">
                                <span class="text-right col-md"> متن و عنوان غیرتکراری</span>

                                <span v-if="expireTime !== '' "
                                      class="float-left col-md mr-11">زمان باقی مانده : {{
                                        parseInt(expireTime / 60) + ":" + (expireTime % 60)
                                    }} </span>
                            </div>

                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn
                                    icon
                                    dark
                                    @click="delOptions"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card-text class="pt-5">
                        <v-text-field :error-messages="productMessage" dense clearable v-model="jobKeyword"
                                      label="نام محصول / خدمات" outlined
                                      clear-icon="mdi-close-circle-outline"></v-text-field>
                        <v-btn v-if="productMessage === '' && jobKeyword !== '' " class="btn-dec-with-text ml-auto"
                               @click="getSuggest">
                            <span class="fa fa-save ml-1" style="font-size: 1.2rem"></span>
                            ثبت پیشنهادات
                        </v-btn>
                        <v-autocomplete label="عنوان پیشنهادی" @change="authenticate" v-if="suggestTexts.titles != null"
                                        @input="setTitle" chips
                                        deletable-chips
                                        :items="suggestTexts.titles"
                                        prepend-inner-icon="fa fa-pencil-alt"
                        >
                        </v-autocomplete>
                        <v-autocomplete label="توضیحات پیشنهادی" v-if="suggestTexts.descriptions !== null"
                                        @input="setDescription"
                                        chips
                                        deletable-chips
                                        :items="suggestTexts.descriptions"
                                        prepend-inner-icon="fa fa-pencil-alt"
                        >
                        </v-autocomplete>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog
                    v-model="defaultDesc"
                    persistent
                    max-width="500"
                    class="px-5"
            >
                <v-card>
                    <v-toolbar
                            flat
                            dark
                            color="primary"
                    >

                        <v-toolbar-title> متن آماده</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn
                                    icon
                                    dark
                                    @click="defaultDesc = false"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card-text class="pt-5">
                        <v-autocomplete label="متن پیشفرض" @input="setDescription" chips deletable-chips
                                        :items="textsDesc"
                                        item-text="description"
                                        prepend-inner-icon="fa fa-pencil-alt"
                                        :id="textsDesc.id">
                            <template v-slot:item="data">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span class="text-capitalize"> {{ index }} -  {{
                                                data.item.description
                                            }} - {{ data.item.category }}</span>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-autocomplete>
                        <v-autocomplete label="آگهی پیشفرض" @input="setDescription" chips deletable-chips :items="Ads"
                                        item-text="description"
                                        prepend-inner-icon="fa fa-pencil-alt"
                                        :id="Ads.id">
                            <template v-slot:item="data">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span class="text-capitalize"> {{ index }} -  {{ data.item.description }}</span>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-autocomplete>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <div class="col-md-8 mx-auto py-0 my-0" v-if="fields.length > 0" v-for="(item,index) in properties"
                 :key="item.label" :data-name="item.label">
                <component
                        :key="item.name"
                        :is="item.name === 'transformable_price' ? 'forRent' :item.component "
                        item-value="key"
                        item-text="lable"
                        :items="item.items"
                        :edit="edit"
                        :counter="enableCounter(item.name)"
                        v-model="item.value"
                        :hint="item.hint"
                        @keypress="allowOnlyNumbers($event,item.name,item.type)"
                        :max="item.counter"
                        :maxLength="item.max"
                        rows="13"
                        :min="item.min"
                        :label="item.label"
                        oninput="if(Number(this.value) > Number(this.max) && this.type === 'number') this.value = this.max"
                        @input="getValue(item.label,$event,item.name,item.type)"
                        outlined
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        small-chips
                        :required="isRequire(item.required)"
                        :rules="item.rules"
                        :prepend-inner-icon="item.icons[0].icon"
                        @click:prepend-inner="item.icons[0].click"
                        @change="reload(item.autoReload,$event,item.name,item.type)"
                        :type="item.type"
                        :loading="loading"
                        :error-messages="item.errorMessage"
                        :name="item.name"
                        :placeholder="item.placeholder"
                        :multiple="item.name === 'colored_parts' "
                        dense>
                </component>
                <v-sheet v-if="emoji === true && item.name === 'title' " class="mb-1" color="white lighten-3"
                         outlined
                         rounded>
                    <v-card-text class="py-0 my-0" style="background-color: rgba(255,255,255,0.45)">
                        <button type="button" v-for="item in titleEmojies"
                                class="btn my-1  align-content-center py-1"
                                @click="emojiPicker"
                                :data-emoji="item">{{ item }}
                        </button>
                    </v-card-text>
                    <v-btn color="error" text @click="emoji = false"><i class="fa fa-times text-danger"></i></v-btn>

                </v-sheet>
                <v-sheet v-if="emojidesc === true && item.name === 'description' " class="mb-1" color="white lighten-3"
                         outlined
                         rounded>
                    <v-card-text class="py-0 my-0" style="background-color: rgba(255,255,255,0.45)">
                        <button type="button" v-for="item in descEmojies"
                                class="btn my-1  align-content-center py-1"
                                @click="emojiPickerdesc"
                                :data-emoji="item">{{ item }}
                        </button>
                    </v-card-text>
                    <v-btn color="error" text @click="emojidesc = false"><i class="fa fa-times text-danger"></i></v-btn>
                </v-sheet>
            </div>
        </div>
    </div>
</template>
<script>
import forRent from '../divarDependency/forRent'
import {VAutocomplete, VHidden, VSelect, VSwitch, VTextarea, VTextField} from 'vuetify/lib';
import {Axios2, Bus} from "../../../../main";

export default {
    name: "inputMaker",
    components: {forRent},
    props: {
        param: {
            type: Object,
            require: true
        },
        fields: {
            default: () => {
                return []
            }
        },
        edit: {
            required:true,
            default:false
        },
        multi: {
            default: false,
        },
        current: {
            default: ''
        },
        multiAdsCat: {
            default: false,
        },
        editField: {
            type: Object,
            default: () => {
                return {}
            }
        },
        auto_change: {
            default: false,
            require: true
        },
    },
    data() {
        return {
            properties: [],
            auto: [],
            Ads: [],
            city: '',
            productMessage: '',
            defaultTitle: false,
            getText: false,
            suggestText: false,
            expireTime: '',
            defaultDesc: false,
            auto_changes: this.auto_change,
            multiFiltered: [],
            suggestTexts: {
                titles: null,
                descriptions: null,
            },
            singleFiltered: [],
            titleEmojies: ["%", "٪", "*", "×", "،", ".", "-", "+", "«", "»", "&", "'", "(", ")", "/"],
            descEmojies: ["✌️", "✅", "♻️", "❎", "✳️", "❇️", "✔️", "☑️", "⚫", "⚪", "▪️", "▫️", "◾", "◽", "◼️", "◻️", "⬛", "⬜", "♾️", "✖️", "➗", "➖", "➕", "↩️", "↪️", "⤵️", "⤴️", "↔️", "↕️", "↖️", "↙️",
                "↘️", "↗️", "⬇️", "⬆️", "⬅️", "➡️", "◀️", "⏬", "⏫", "⏪", "⏩", "*️⃣", "#️⃣"],
            titleValue: "",
            texts: [],
            textsDesc: [],
            descriptionValue: "",
            loading: false,
            iconIndex: 0,
            inputs: {
                "radio": VSelect,
                "string": VTextField,
                "TextFieldWidget": VTextField,
                "number": VTextField,
                "hierarchy_widget": VSelect,
                "SingleSelectHierarchyWidget": VSelect,
                "select": VAutocomplete,
                "textarea": VTextarea,
                "boolean": VSwitch,
                "hidden": VHidden,
                "array": VAutocomplete,
                "object": VAutocomplete,
                "checkboxes": VAutocomplete
            },
            icons: [
                'mdi-emoticon',
                'mdi-emoticon-angry',
                'mdi-emoticon-excited',
            ],
            emoji: false,
            emojidesc: false,
            jobKeyword: '',
            parameters: this.param,
            timer: null,
            queryString: new URLSearchParams(),
        };
    },
    methods: {
        validate() {
            if (this.current === '') {
                this.$modal.error('خطا!', 'لطفا دسته موردنظرتان را انتخاب کنید.');
                return false;
            }

            let validate = true;

            this.properties.filter((x) => x.required === true).forEach((x) => {
                if (this.parameters[x.name]) {
                    validate = validate && true;
                } else {
                    x.errorMessage = 'واردکردن فیلد ' + ' «' + x.label + '» ' + 'الزامی است.'
                    validate = false;
                }
            })

            return validate;
        },
        getProperty(key) {
            const name = key.name;
            const min = key.min
            const max = key.max;
            const help = key.placeholder;
            const requireField = key.required;
            const placeholder = key.placeholder;
            const autoReload = key.auto_refresh;
            const has_field = key.fields
            let items = [];
            let type = key.field_type !== null ? key.field_type : (key.type !== 'integer' ? key.type : "number");
            let title = key.title;
            let itemValue = key.enum ?? [];
            let itemText = key.enumNames ?? itemValue;

            itemValue.forEach((item, index) => {
                items.push({
                    key: item,
                    lable: itemText[index]
                })
            })

            if (Object.keys(this.editField).length > 0) {
                if (this.timer != null)
                    clearTimeout(this.timer);

                this.timer = setTimeout(() => {
                    this.current = this.editField.category
                    this.editForm();
                    this.parameters = this.param
                    this.timer = null;
                }, 500);
            }

            return {
                component: this.inputs[type],
                label: title,
                counter: max ? max : null,
                hint: help ? help : null,
                items: items,
                name: name,
                min: min,
                value: "",
                required: requireField,
                placeholder: placeholder,
                has_fields: has_field,
                errorMessage: "",
                autoReload: autoReload,
                rules: [
                    (v) => {
                        if ((name === "title" || name === "description"))
                            return (this.required === true ? v < max : v.length <= max) || 'مقدار وارد شده بیش از حد مجاز است.حداکثر مقدار موردنیاز ' + max + ' است.';
                        else if (["boolean", "select", "string", "object", "number", "array", "hidden", "radio", "SingleSelectHierarchyWidget", "checkboxes", "hierarchy_widget"].indexOf(type) > -1)
                            return true;
                    },
                    (v) => {
                        if ((name === "title" || name === "description"))
                            return (this.required === true ? v > min : v.length >= min) || 'مقدار وارد شده کمتر از حد مجاز است.حداقل مقدار موردنیاز  ' + min + ' است.';
                        else if (["boolean", "select", "object", "string", "number", "array", "hidden", "number", "radio", "checkboxes", "hierarchy_widget"].indexOf(type) > -1)
                            return true;

                    },
                ],
                icons: [
                    {
                        icon: 'mdi-emoticon' ? title === 'عنوان آگهی' || title === 'توضیحات آگهی' ? this.icon : 'fas fa-pencil-alt' : this.icon,
                        click: () => {
                            if (title === 'عنوان آگهی')
                                this.emoji = true;
                            else if (title === "توضیحات آگهی")
                                this.emojidesc = true
                            else return false;
                        }
                    },
                    {
                        icon: 'mdi-emoticon' ? title === 'عنوان آگهی' || title === 'توضیحات آگهی' ? 'fa fa-edit' : '' : 'fa fa-edit',
                        click: () => {
                            if (title === 'عنوان آگهی') {
                                this.defaultTitle = true
                            } else if (title === 'توضیحات آگهی') {
                                this.defaultDesc = true
                            }
                        }
                    },
                    {
                        icon: 'mdi-emoticon' ? title === 'عنوان آگهی' ? 'fa fa-check' : '' : 'mdi-emoticon',
                        click: () => {
                            if (this.titleValue.length > 0 && (this.suggestTexts.titles === null)) {
                                this.authenticate();
                            } else {
                                this.getText = true;
                                this.getCookie('timer');
                            }
                        }
                    },
                ],
                type: type,
            };
        },
        getValue(title, value, name, type) {
            if (title === 'عنوان آگهی') {
                this.itemType = title;
                this.titleValue = value;
            } else if (title === 'توضیحات آگهی') {
                this.descriptionValue = value;
            }

            this.properties.find((x) => x.name === name).errorMessage = "";
        },
        emojiPicker(element) {
            const $title = $('[name = "title"]')[0];

            let currentInput = this.titleValue;
            let cursorPos = $title.selectionStart;
            let textBefore = currentInput.substring(0, cursorPos);
            let textAfter = currentInput.substring(cursorPos, currentInput.length);

            this.titleValue = textBefore + $(element.target).data("emoji") + textAfter;
            this.properties.find((x) => x.name === 'title').value = this.titleValue;

            this.$nextTick(function () {
                $title.focus();
                $title.setSelectionRange(cursorPos, cursorPos);
            })
        },
        emojiPickerdesc(element) {
            const $title = $('[name = "description"]')[0];

            let currentInput = this.descriptionValue;
            let cursorPos = $title.selectionStart;
            let textBefore = currentInput.substring(0, cursorPos);
            let textAfter = currentInput.substring(cursorPos, currentInput.length);

            this.descriptionValue = textBefore + $(element.target).data("emoji") + textAfter;
            this.properties.find((x) => x.name === 'description').value = this.descriptionValue;

            this.$nextTick(function () {
                $title.focus();
                $title.setSelectionRange(cursorPos, cursorPos);
            })
        },
        generateQueryString(key, value) {
            this.queryString.delete(key);
            this.queryString.append(key, value);
        },
        reload(isAutoReload, value, name, type) {
            switch (type) {
                case "boolean":
                    const bol = Boolean(value);
                    if (bol)
                        this.parameters[name] = bol;
                    break;
                case "number":
                    this.parameters[name] = Number(value);
                    break;
                default:
                    this.parameters[name] = value;
                    break;
            }
            this.generateQueryString(name, value)
            if (isAutoReload === true) {
                $.ajax(
                    {
                        url: `${url}/divar/categories/${this.current}/dependency?`,
                        method: 'POST',
                        dataType: 'json',
                        data: JSON.stringify(this.parameters),
                        fn: this.reload,
                        params: [isAutoReload, value, name, type],
                        headers: {
                            'Authorization': Token,
                            'Content-Type': 'application/json',
                            "ACCEPT": "application/json",
                        },
                        success: (data) => {
                            const response = this.multiAdsCat === true ? data.data.filter(x => !this.multiFiltered.includes(x.name)) : data.data.filter(x => !this.singleFiltered[x.name])
                            Bus.$emit('reload', response);
                        }
                    }
                );
            }
        },
        editForm() {
            this.queryString.forEach((value, key) => {
                this.queryString.delete(key);
            });

            Object.keys(this.editField).forEach((key) => {
                if (typeof this.editField[key] != 'object')
                    this.queryString.set(key, this.editField[key]);
            });
            this.titleValue = this.editField.title
            this.descriptionValue = this.editField.description

            $.ajax(
                {
                    url: `${url}/user/divar/dependency/${this.current}?` + this.queryString.toString(),
                    type: 'POST',
                    dataType: 'json',
                    fn: this.editForm,
                    headers: {
                        'Authorization': Token,
                        "ACCEPT": "application/json",
                    },
                    success: (data) => {
                        Object.keys(this.editField).forEach((key) => {
                            let item = this.properties.find((x) => x.name === key);


                            if (key === "credit") {
                                let value = {
                                    "credit": this.editField.credit,
                                    "rent": this.editField.rent,
                                    "transformed_credit": undefined,
                                    "transformed_rent": undefined,
                                    "transformable": false
                                }
                                // this.properties.find((x) => x.name === "transformable_price")["value"] = value;
                            } else if (typeof this.editField[key] != 'object' && item) {
                                let value = this.editField[key];

                                if (key === 'rooms')
                                    value = ["بدون اتاق", "یک", "دو", "سه", "چهار", "پنج یا بیشتر"][value];
                                else if (key === 'floor' && value > 30)
                                    value = "30+";
                                else if (key === 'floor' && value < 30)
                                    value = String(value)
                                else if (key === 'year' && value < 1370)
                                    value = "قبل از ۱۳۷۰"
                                else if (key === 'year' && value > 1370)
                                    value = String(value).replace(/[0-9]/g, c => String.fromCharCode(c.charCodeAt(0) + 1728))

                                this.properties.find((x) => x.name === key)["value"] = value;
                            }
                        });
                    }
                }
            );
        },
        allowOnlyNumbers(value, name, type) {
            if (type === 'number') {
                let allowedKeys = [8, 46, 38, 40, 37, 39];
                const keypressed = value.which || value.keyCode;
                if (/[^0-9\s]+/.test(value.key)) {
                    if (allowedKeys.every(e => e !== keypressed)) {
                        value.preventDefault();
                    }
                } else return true
            }
        },
        enableCounter(name) {
            if (name === "title") {
                return 50;
            } else if (name === "description") {
                return 1000;
            } else
                return false
        },
        isRequire(requirement) {
            if (requirement === true) {
                return true;
            } else
                return false;
        },
        getTitles() {
            $.ajax({
                url: `${url}/default/text/all`,
                method: "GET",
                fn: this.getTitles,
                headers: {
                    ACCEPT: 'application/json',
                    Authorization: Token,
                    "Content-Type": 'application/json'
                },
                success: (data) => {
                    this.texts = data;
                    this.textsDesc = data;
                }
            })
        },
        setTitle(e) {
            this.properties.find((x) => x.name === 'title')["value"] = e;
            this.titleValue = e;
            this.parameters['title'] = this.titleValue;
            this.defaultTitle = false
        },
        setDescription(e) {
            this.properties.find((x) => x.name === 'description')["value"] = e;
            this.descriptionValue = e;
            this.parameters['description'] = this.descriptionValue;
            this.defaultDesc = false

        },
        getTitlesAds() {
            $.ajax({
                url: `${url}/default/own/all`,
                method: "GET",
                fn: this.getTitles,
                headers: {
                    ACCEPT: 'application/json',
                    Authorization: Token,
                    "Content-Type": 'application/json'
                },
                success: (data) => {
                    this.Ads = data
                }
            })
        },
        authenticate() {
            this.$modal.showLoading();
            $.ajax({
                url: `${url}/divar/check/title`,
                type: "POST",
                fn: this.authenticate,
                headers: {
                    ACCEPT: "application/json",
                    Authorization: Token,
                    "Content-type": 'application/json'
                },
                data: JSON.stringify({
                    "title": this.titleValue,
                    "city": String(this.city),
                    "category": this.current
                }),
                msg: false,
                error: (data) => {
                    if (data.status === 422) {
                        this.$modal.error('خطا', 'لطفا اطلاعات فرم را کامل نمایید.')
                    } else {
                        this.$modal.error('خطا', 'عنوان مورد نظر قابل قبول نمی باشد.');
                        this.suggestTexts.titles.splice(this.suggestTexts.titles.indexOf(this.titleValue, 1));
                    }

                },
                success: (data) => {
                    this.$nextTick(function () {
                        this.$modal.success(data.message);
                    })
                }
            });

        },
        getSuggest() {
            this.$modal.showLoading();
            if (this.expireTime === '') {
                Axios2.post('/shop/default', JSON.stringify({
                    "category": this.current,
                    "city": String(this.city),
                    "keyword": this.jobKeyword,
                    "length": 10
                })).then((response) => {
                    this.$modal.hideLoading();
                    if (response.data.data.length <= 0) {
                        this.$modal.error('خطا!', 'اطلاعات آگهی و یا نام محصول صحیح نیست.');
                    } else {
                        localStorage.removeItem('suggestions');
                        this.suggestTexts.titles = response.data.data.map(x => x.title);
                        this.suggestTexts.descriptions = response.data.data.map(x => x.description);
                        // this.setCookies('timer', 'time', 10);
                        localStorage.setItem('suggestions', response.data.data);
                    }

                }).catch((error) => {
                    this.$modal.error('خطا!', 'لطفا اطلاعات فرم را تکمیل فرمایید!');
                })
            } else this.$modal.info('هشدار!', 'تاپایان زمان باقی مانده شما قادر به ایجاد درخواست جدید نیستید.')
        },
        delOptions() {
            this.getText = false;
            if (this.titleValue != null || this.titleValue !== '' || this.titleValue !== undefined)
                this.suggestTexts.titles.splice(this.suggestTexts.titles.indexOf(this.titleValue), 1);

            if (this.descriptionValue != null || this.descriptionValue !== '' || this.descriptionValue !== undefined)
                this.suggestTexts.descriptions.splice(this.suggestTexts.descriptions.indexOf(this.descriptionValue), 1);
        },
        setCookies(key, value, min) {
            const d = new Date();
            d.setTime(d.getTime() + (min * 60 * 1000));
            let expires = "expires=" + d.toUTCString();
            document.cookie = key + "=" + value + ";" + expires + ";path=/";
            document.cookie = key + "_expire=" + expires.replace("expires=", "");
        },
        getCookie(key) {
            let cookies = document.cookie.split(";")
            let now = new Date();

            let newCookies = cookies.filter((item) => item.indexOf("_expire") > -1).map((item) => {
                let expire_cookie = item.trim().split("=");
                let cookie = cookies.find(x => x.indexOf(expire_cookie[0].replace("_expire", "") + "=") > -1)?.trim()?.split("=") || [];
                let expire = new Date(expire_cookie[1]);
                this.expireTime = parseInt((expire.getTime() / 1000) - (now.getTime() / 1000));

                return {
                    name: expire_cookie[0].replace("_expire", ""),
                    value: cookie[1] || null,
                    expire_at: parseInt((expire.getTime() / 1000) - (now.getTime() / 1000))
                }
            });

            return newCookies.find((item) => item.name === key);
        }
    },
    watch: {
        titleValue(value) {
            const count = (value.match(/[%٪\*×،\.\-\+«»&'\(\)\/]/g) || []).length
            const title = this.properties.find(x => x.name === 'title');

            if (count > 4 || value.match('#')) {
                title.errorMessage = 'عنوان آگهی تنها می‌تواند شامل حروف الفبا، اعداد و 4 نوع از علامت‌های % ٪ * × ، . - + « » & \' ( ) / باشد';
                this.iconIndex = 1;
            } else {
                title.errorMessage = '';
            }
        },
        descriptionValue(value) {
            const descriptions = this.properties.find(x => x.name === 'description');
            if (value.length >= 10) {
                descriptions.errorMessage = ''
            }
        },
        fields(val) {
            this.properties = [];

            this.fields.forEach((item) => {
                this.properties.push(this.getProperty(item));
            });

            Bus.$emit('properties', this.properties)
        },
        parameters: {
            handler: function () {
                Bus.$emit('parameters', this.parameters);
            },
            deep: true
        },
        jobKeyword: function (value) {
            this.keyWord = value;
            const sillabels = this.keyWord.split(' ').filter(x => x);
            if (sillabels.length < 2) {
                this.productMessage = 'حداقل 2 کلمه باید وارد شود';
            } else if (sillabels.length >= 5) {
                this.productMessage = 'حداکثر 4 کلمه باید وارد شود';
            } else {
                this.productMessage = '';
            }

        },
        expireTime(val) {
            if (val === 0) {
                this.jobKeyword = '';
            }
            if (val <= 0) {
                this.expireTime = '';
            }
        },
    },
    computed: {
        fieldCashed() {
            return this.fields;
        },
        icon() {
            return this.icons[this.iconIndex]
        },
    },
    mounted() {
        if (Object.keys(this.editField).length > 0) {
            this.editForm();
        }
        Bus.$on('category-multi-filtered', (multiFiltered) => {
            this.multiFiltered = multiFiltered;
        });
        Bus.$on('category-single-filtered', (singleFiltered) => {
            this.singleFiltered = singleFiltered;
        });
        Bus.$on('category-current', (cuurent) => {
            this.current = cuurent;
        });
        Bus.$on('cityInfo', (value) => {
            this.city = value.city;
            this.neighborhood = value.neighborhood;
        });
        setInterval(() => {
            this.getCookie('timer')
        }, 1000)
    }
}
</script>
<style>
.fa-pencil-alt {
    font-size: 17px !important;
}

.font-20 {
    font-size: 16pt;
}

.symbol {
    border: 2px solid rgba(255, 255, 255, 0.45);
    min-width: 3rem !important;
    max-width: 3rem !important;
    min-height: 2rem !important;
    max-height: 3rem !important;
    text-align: center;
    box-shadow: -5px -5px 9px rgba(255, 255, 255, 0.45), 5px 5px 9px rgba(94, 104, 121, 0.3);
    background-color: rgba(255, 255, 255, 0.45);
    color: #1c0152;
}

.symbol:hover {
    box-shadow: -5px -5px 9px rgba(255, 255, 255, 0.45), 5px 5px 9px rgba(94, 104, 121, 0.3);
    transition-delay: 0.1s;
    color: #1c0152;
}
</style>